import React from "react"
import propTypes from "prop-types"

import OneOffPurchasesCard from "../../../../components/OneOffPurchasesCard"
import DailyOrWeeklyServicesCard from "../../../../components/DailyOrWeeklyServicesCard"
import RecurringActivitiesCard from "../../../../components/RecurringActivitiesCard"
import RecurringPurchasesCard from "../../../../components/RecurringPurchasesCard"

class RequiredServices extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      services: [],
      goals: []
    }
  }

  componentDidMount() {
    this.updateServices()

    this.updateGoals()
  }

  componentDidUpdate(prevProps) {
    const { requiredServices, myGoals } = this.props

    if (requiredServices) {
      if (
        JSON.stringify(prevProps.requiredServices) !==
        JSON.stringify(requiredServices)
      ) {
        this.updateServices()
      }
    }

    if (myGoals) {
      if (JSON.stringify(prevProps.myGoals) !== JSON.stringify(myGoals)) {
        this.updateGoals()
      }
    }
  }

  updateServices = () => {
    const { requiredServices } = this.props

    if (requiredServices.length) {
      const services = []

      requiredServices.map(requiredService => {
        const key = Object.keys(requiredService)[0]

        requiredService[key].map(requiredServiceInner => {
          services.push(requiredServiceInner)

          return null
        })

        return null
      })

      this.setState({
        services
      })
    }
  }

  updateGoals = () => {
    const { myGoals } = this.props

    if (myGoals) {
      this.setState({
        goals: myGoals.goal
      })
    }
  }

  render() {
    const { services, goals } = this.state
    const { removeItem } = this.props

    const oneOffPurchase = []
    const weeklyActivity = []
    const recurringActivity = []
    const recurringPurchase = []

    services.map(service => {
      if (service.item_type === "one_off_purchase") {
        oneOffPurchase.push(service)
      } else if (service.item_type === "weekly_activity") {
        weeklyActivity.push(service)
      } else if (service.item_type === "recurring_activity") {
        recurringActivity.push(service)
      } else if (service.item_type === "recurring_purchase") {
        recurringPurchase.push(service)
      }

      return null
    })

    return (
      <div className="row">
        <div className="col-md-10 offset-md-1">
          {!!oneOffPurchase.length && (
            <OneOffPurchasesCard
              services={oneOffPurchase}
              goals={goals}
              removeItem={removeItem}
              editLink
            />
          )}

          {!!weeklyActivity.length && (
            <DailyOrWeeklyServicesCard
              services={weeklyActivity}
              goals={goals}
              removeItem={removeItem}
              editLink
            />
          )}

          {!!recurringActivity.length && (
            <RecurringActivitiesCard
              services={recurringActivity}
              goals={goals}
              removeItem={removeItem}
              editLink
            />
          )}

          {!!recurringPurchase.length && (
            <RecurringPurchasesCard
              services={recurringPurchase}
              goals={goals}
              removeItem={removeItem}
              editLink
            />
          )}
        </div>
      </div>
    )
  }
}

RequiredServices.defaultProps = {
  requiredServices: {},
  myGoals: {
    goal: []
  }
}

RequiredServices.propTypes = {
  requiredServices: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.shape({})),
    propTypes.shape({})
  ]),
  myGoals: propTypes.shape({
    goal: propTypes.arrayOf(propTypes.shape({}))
  }),
  removeItem: propTypes.func.isRequired
}

export default RequiredServices
